import * as React from 'react';
import API from 'api';

import { ListingFormState } from '../types';

type CardsMapType = {
  freehold: {
    sale: Set<string>;
    lease: Set<string>;
  };
  land: {
    sale: Set<string>;
    lease: Set<string>;
  };
  condo: {
    sale: Set<string>;
    lease: Set<string>;
  };
  income: {
    sale: Set<string>;
    lease: Set<string>;
  };
  commercial: Set<string>;
};

const residentialFieldsMap = {
  sale: new Set([
    'photos',
    'virtualTour',
    'description',
    'location',
    'exterior',
    'propertyDetails',
    'rooms',
    'attachments',
  ]),
  lease: new Set([
    'photos',
    'virtualTour',
    'description',
    'location',
    'exterior',
    'propertyDetails',
    'required',
    'includedExcluded',
    'rooms',
    'attachments',
  ]),
};

const cardsMap: CardsMapType = {
  freehold: residentialFieldsMap,
  land: residentialFieldsMap,
  income: residentialFieldsMap,
  condo: {
    sale: new Set([
      'photos',
      'virtualTour',
      'description',
      'location',
      'condoDetails',
      'propertyDetails',
      'rooms',
      'attachments',
    ]),
    lease: new Set([
      'photos',
      'virtualTour',
      'description',
      'location',
      'condoDetails',
      'propertyDetails',
      'required',
      'rooms',
      'attachments',
    ]),
  },
  commercial: new Set([
    'photos',
    'virtualTour',
    'description',
    'location',
    'exterior',
    'moreInfo',
    'financials',
    'propertyDetails',
    'rooms',
    'attachments',
  ]),
};

type UseCardsType = (listing: ListingFormState) => Set<string>;

const useCards: UseCardsType = ({ type, subtype }) => {
  const [openHousesEnabled, setOpenHousesEnabled] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      const fetchedOrgSettings = await API.GET.getOrgSettings();
      if (fetchedOrgSettings?.enableOpenHouses) setOpenHousesEnabled(true);
    })();
  }, []);

  const cards = React.useMemo((): Set<string> => {
    if (!type || !subtype) return new Set();

    let baseSet;
    if (type === 'commercial') {
      baseSet = new Set([...cardsMap.commercial]);
    } else {
      baseSet = new Set([...cardsMap[type][subtype]]);
    }

    if (openHousesEnabled) baseSet.add('openHouses');

    return baseSet;
  }, [type, subtype, openHousesEnabled]);

  return cards;
};

export default useCards;
